import React, { useContext, createContext, PropsWithChildren, JSX } from 'react';
import { UseTranslationResponse } from 'react-i18next';

export type GlobalTranslationFunction = (
  namespace: string,
  keys?: unknown
) => UseTranslationResponse<string, string>;

export const GlobalTranslationContext = createContext<GlobalTranslationFunction | undefined>(
  undefined
);

export const GlobalTranslationContextProvider = ({
  globalTranslation,
  children
}: PropsWithChildren<{
  globalTranslation: GlobalTranslationFunction;
}>): JSX.Element => {
  return (
    <GlobalTranslationContext.Provider value={globalTranslation}>
      {children}
    </GlobalTranslationContext.Provider>
  );
};

const useGlobalTranslation = (): GlobalTranslationFunction | undefined => {
  return useContext(GlobalTranslationContext);
};

export default useGlobalTranslation;
